module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BlackIt.a9afb1a0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BlackIt.woff2
// module id = 356
// module chunks = 3